import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { RefDataDropdownComponent } from '../../shared/components/ref-data-dropdown/ref-data-dropdown.component';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { RefDataService } from '../../shared/services/ref-data.service';
import { RefDataItem, RefDataType } from '../../shared/data-objects/ref-data-item';
import { User } from '../../shared/data-objects/user';
import { ActivatedRoute } from '@angular/router';

const numberRE = /^[0-9]*$/;
const emailRE = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css']
})
export class UserDetailsComponent implements OnInit {
  @Input()
  applicantDetails: User;
  @Input()
  isLandlineMandatory: boolean;
  @Input()
  isMobileMandatory: boolean;
  @Input()
  userEmail: string;
  @Input()
  userRegistration: boolean;
  @ViewChild('title') titles: RefDataDropdownComponent;

  emailControl: FormControl;
  confirmEmailControl: FormControl;
  phoneNumberControl: FormControl;
  // mobileNumberControl: FormControl;
  firstNameControl: FormControl;
  lastNameControl: FormControl;

  emailControlGroup: FormGroup;

  emailControlLength = 50;
  firstNameControlLength = 50;
  lastNameControlLength = 50;
  phoneNumberControlMaxLength = 10;
  phoneNumberControlMinLength = 10;

  mobileNumberControlLength = 10;

  confirmEmailAddress: string;

  errorMessage: string;

  constructor(private refDataService: RefDataService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    // init field controls
    this.initControls();

    const pleaseSelect: RefDataItem[] = [new RefDataItem(0, 'Please Select...')];
    this.refDataService.retrieveReferenceData(RefDataType.Titles, '').subscribe(
      (refDataItems) => {
        this.titles.items = pleaseSelect.concat(refDataItems);
        if (this.applicantDetails) {
          for (let i = 0; i < this.titles.items.length; i++) {
            if (this.applicantDetails.title === this.titles.items[i].display) {
              this.titles.selectedItemId = this.titles.items[i].id;
              break;
            }
          }
        }
      },
      err => {
        this.errorMessage = 'Server error';
      });

      if (this.userRegistration) {
        (this.applicantDetails || {})['email'] = this.userEmail;
        this.confirmEmailAddress = this.userEmail;
      }
  }

  private initControls() {
    this.firstNameControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.firstNameControlLength)
    ])]);
    this.lastNameControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.lastNameControlLength)
    ])]);
    this.emailControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.emailControlLength),
      Validators.pattern(emailRE)
    ])]);
    this.confirmEmailControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.emailControlLength),
      Validators.pattern(emailRE)
    ])]);

    this.phoneNumberControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.phoneNumberControlMaxLength),
      Validators.minLength(this.phoneNumberControlMinLength),
      Validators.pattern(numberRE)
    ])]);

    if (this.isLandlineMandatory) {
      const existingValidators = this.phoneNumberControl.validator;
      this.phoneNumberControl.setValidators(Validators.compose([existingValidators, Validators.required]));
    }

    // this.mobileNumberControl = new FormControl('', [Validators.compose([
    //   Validators.maxLength(this.mobileNumberControlLength),
    //   Validators.minLength(this.mobileNumberControlLength),
    //   Validators.pattern(numberRE)
    // ])]);

    // if (this.isMobileMandatory) {
    //   const existingValidators = this.mobileNumberControl.validator;
    //   this.mobileNumberControl.setValidators(Validators.compose([existingValidators, Validators.required]));
    // }

    if (!this.userEmail) {
      this.userEmail = atob(this.activatedRoute.snapshot.queryParamMap.get('u') || '').toLowerCase();
    }

    this.emailControlGroup = new FormGroup({
      email: this.emailControl,
      confirmEmail: this.confirmEmailControl
    }, (g: FormGroup): ValidationErrors => {
      return { areEqual: g.controls.email.value !== g.controls.confirmEmail.value };
    });
  }

  public handleTitleChanged($event) {
    const selectedItem: RefDataItem = this.titles.selectedItem;
    if (selectedItem) {
      this.applicantDetails.title = selectedItem.display;
    }
  }

  get invalid(): boolean {
    return this.emailControlGroup.hasError('areEqual') ||
      this.emailControl.invalid ||
      this.phoneNumberControl.invalid ||
      // this.mobileNumberControl.invalid ||
      this.firstNameControl.invalid ||
      this.lastNameControl.invalid;
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-users/user-details/user-details.component.ts